












export default {
  name: "Banner",
  props: {
    banner: { type: Array, default: () => [] },
  },
};
